
define('modules/application/wizard/steps/zoneStep/complexZoneStep/intrusionDetectionZoneStep/zonesMenuView',[
  "app",

  // Libs
  "backbone",
  "jqueryUi",

  //Class
  "../zonesMenuView",
  "../zoneMenuView",
  "./zoneDetailView",
  "../../separatorMenuView"
],

function(
  app,
  Backbone,
  jQueryUi,
  ZonesMenuView,
  ZoneMenuView,
  ZoneDetailView,
  SeparatorMenuView) {

  var intrusionDetectionZonesMenuView = ZonesMenuView.extend({

    addConstructors : function() {
      this.ZoneMenuView       = ZoneMenuView;
      this.ZoneDetailView     = ZoneDetailView;
      this.SeparatorMenuView  = SeparatorMenuView;
    },

    beforeRender : function() {
      var viewToSelect;
      var additionalZoneToInsert = this.insertAdditionalZones();
      var regularZoneToInsert    = this.insertRegularZones();

      if (additionalZoneToInsert)
        window.BticinoS4B.eventAggregator.trigger("zone:selected", additionalZoneToInsert);

      if (regularZoneToInsert)
      {
        new this.ZoneDetailView({
          model               : _.extend({stepEventAggregator : this.options.stepEventAggregator}, regularZoneToInsert.model),
          sections            : this.options.model.get("sections")
        });
        window.BticinoS4B.eventAggregator.trigger("zone:selected", regularZoneToInsert);
      }
    }

  });

  //Creating final complexZoneStep class
  intrusionDetectionZonesMenuView.extend({
    objClass      : "intrusionDetectionZonesMenuView"
  });

  // Required, return the module for AMD compliance
  return intrusionDetectionZonesMenuView;

});